import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationService } from '../../../core/service/navigation.service';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LogoComponent implements OnInit {
  constructor(private _navigation: NavigationService) {}

  onclick() {
    this._navigation.navigateHome();
  }

  ngOnInit() {}
}
